import { useEffect } from "react";

const CustomTooltip = ({ active, payload, label }) => {

  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip">
        <p className="label">{`${payload[0].payload.trendValue} (${payload[0].payload.trendTag}) : ${payload[0].value}`}</p>
      </div>
    );
  }

  return null;
};

export default CustomTooltip
